import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authSelector } from '../features/auth/slice';

const h = window.location.hostname;
const isDistDomain = h === 'kdist.net' || (h.endsWith('.kdist.net') && h.split('.').length === 3);

const PUBLIC_BASE =
  isDistDomain
    ? ''
    : (h === 'impink.co.kr' || h === 'www.impink.co.kr' || h === 'urpink.co.kr' || h === 'www.urpink.co.kr' || h === 'localhost' || h === '100.68.115.13' || h === '100.116.73.97')
      ? ''
      : '/public';

const LOGIN_PATH = isDistDomain ? '/login' : `${PUBLIC_BASE}/login?tab=client`;

const PrivateRoute = () => {
  const { me, loading, userType } = useSelector(authSelector.selectAuthState);
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  if (loading) {
    return null;
  }

  if (userType === 'member') {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  if (!me) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
